export class ParameterListDTO {
    
    key: string;
    
    value: string;

}
